import React from "react";
import {
  Box,
  Icon,
  Step,
  StepIndicator,
  StepSeparator,
  Stepper,
  Tag,
  TagLabel,
  VStack,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaCheck } from "react-icons/fa";
import { PrimaryCard } from "../common/cards";

/**
 * Renders the organised services card
 * 
 * @param {Object} props The component properties
 * @returns The organised services card
 */
const OrganisedServicesCard = ({ status }) => {
  const { t } = useTranslation();

  const orientation = useBreakpointValue({
    base: "vertical",
    sm: "horizontal",
  });

  const statuses = {
    called: "#E1251B",
    completed: "#FFB600",
    contacted: "#54C0E8",
    accessed: "#C4C4C4",
    closed: "#32C476",
  };

  return (
    <PrimaryCard title={t("beneficiaryFileStatus.fileStatus.title")}>
      <VStack alignItems={"stretch"} gap={8}>
        <Box
          alignSelf={"center"}
          backgroundColor={"#32C476"}
          borderRadius={"full"}
          padding={8}
        >
          <Icon as={FaCheck} boxSize={{ base: 12, sm: 24 }} color={"white"} />
        </Box>
        <Stepper
          height={orientation === "vertical" ? "400px" : ""}
          orientation={orientation}
        >
          {Object.entries(statuses).map(([key, value]) => (
            <Step alignSelf={"center"} key={key}>
              <StepIndicator width={"80px"}>
                <Tag backgroundColor={value} borderRadius={100} color={"white"}>
                  <TagLabel>
                    {t(`beneficiaryFileStatus.status.${key}`)}
                  </TagLabel>
                </Tag>
              </StepIndicator>
              <StepSeparator _vertical={{ left: "40px" }} />
            </Step>
          ))}
        </Stepper>
      </VStack>
    </PrimaryCard>
  );
};

export default React.memo(OrganisedServicesCard);
